const MessageReader = require('@homeaway/stab-message-reader');
const CATEGORY = 'messages';

/**
 * Read a message via a key and variable options object
 * @param key String
 * @param options Object containing name/value pairs
 * @category lingua key category
 */
function read(key, options, category) { // eslint-disable-line complexity
    if (typeof category === 'undefined') {
        return MessageReader.read(key, options, CATEGORY);
    }
    /* istanbul ignore next */
    return MessageReader.read(key, options, category);
}

/**
 * Determine if a key is supported for the current locale
 * @param key String
 * @return keyExists Boolean
 */
function exists(key) {
    return MessageReader.exists(key, CATEGORY);
}

module.exports = {
    read,
    exists
};